import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { CalendarDays, MapPin, ArrowLeft, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import api, { resolveImg } from "@/lib/api";
import { formatDate } from "@/lib/format";
import { useSeo } from "@/hooks/useSeo";
import PageHeader from "@/components/PageHeader";

const KegiatanDetail = () => {
  const { slug } = useParams();
  const [a, setA] = useState(null);
  const [notFound, setNotFound] = useState(false);
  useSeo(a?.title || "Kegiatan", a?.excerpt);

  useEffect(() => {
    api.get(`/activities/${slug}`).then((r) => setA(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 text-center px-6">
      <p className="text-slate-500">Kegiatan tidak ditemukan.</p>
      <Link to="/kegiatan"><Button variant="outline" className="gap-2 border-emerald-200 text-emerald-700"><ArrowLeft className="h-4 w-4" /> Kembali</Button></Link>
    </div>
  );
  if (!a) return <div className="flex min-h-[60vh] items-center justify-center"><Loader2 className="h-8 w-8 animate-spin text-emerald-600" /></div>;

  return (
    <div>
      <PageHeader title={a.title} crumbs={[{ label: "Kegiatan", to: "/kegiatan" }, { label: "Detail" }]} />
      <article className="mx-auto max-w-3xl px-6 py-14">
        <div className="mb-6 flex flex-wrap items-center gap-4 text-sm text-slate-500">
          <span className="flex items-center gap-1.5"><CalendarDays className="h-4 w-4 text-emerald-600" />{formatDate(a.date)}</span>
          {a.location && <span className="flex items-center gap-1.5"><MapPin className="h-4 w-4 text-emerald-600" />{a.location}</span>}
        </div>
        {a.image_url && <img src={resolveImg(a.image_url)} alt={a.title} className="w-full rounded-2xl object-cover shadow-sm" />}
        <div className="mt-8">
          <p className="text-lg font-medium text-slate-700">{a.excerpt}</p>
          {(a.content || "").split("\n").filter(Boolean).map((para, i) => (
            <p key={i} className="mt-4 leading-relaxed text-slate-600">{para}</p>
          ))}
        </div>
        <div className="mt-10">
          <Link to="/kegiatan"><Button variant="outline" className="gap-2 border-emerald-200 text-emerald-700" data-testid="activity-back-button"><ArrowLeft className="h-4 w-4" /> Kembali ke Kegiatan</Button></Link>
        </div>
      </article>
    </div>
  );
};

export default KegiatanDetail;
